
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers/voice/2",
      function () {
        return require("private-next-pages/careers/voice/2/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/careers/voice/2"])
      });
    }
  